export enum CardBrand {
  visa = '1',
  mastercard = '2',
  discover = '3',
  amex = '4',
}
